class AAHeadquartersClients {
 constructor(root) {
  this.root = root;
  this.clients = [];
  this.archivedClients = [];
 this.activeClientId = null;
this.editingClientId = null;
this.addingCatalogClientId = null;
this.editingCatalogId = null;

this.clientPlaybooks = [];
this.clientPlaybooksLoading = false;

this.init();
}

  async init() {
  await this.loadClients();
  await this.loadActiveClientPlaybooks();

  this.bindClientActions();
  this.bindNewClientForm();
  this.render();
}

  escapeHtml(value = '') {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  clone(value) {
    return JSON.parse(JSON.stringify(value));
  }
  showStatusMessage(message, type = 'success') {
  let status = this.root.querySelector('[data-aa-client-status]');

  if (!status) {
    status = document.createElement('div');
    status.setAttribute('data-aa-client-status', '');
    status.className = 'aa-client-status-message';

    const container = this.root.querySelector('[data-aa-clients-list]');
    if (container?.parentNode) {
      container.parentNode.insertBefore(status, container);
    }
  }

  status.textContent = message;
  status.dataset.statusType = type;

  window.clearTimeout(this.statusMessageTimer);

  this.statusMessageTimer = window.setTimeout(() => {
    if (status) {
      status.textContent = '';
    }
  }, 3000);
}

  getClientDefaults() {
    return {
      id: '',
      business_name: '',
      primary_contact: '',
      email: '',
      phone: '',
      client_type: 'Monthly Marketing',
      current_package: 'Monthly Marketing',
      active_status: 'Pending Setup',
      account_status: 'Pending Setup',
      invoice_status: 'Current',
      workspace_status: 'Not Created',
      contract_status: 'No Contract',
      monthly_due_day: '15',
      reminder_schedule: '5 & 2 days',
      reminder_email_template: 'Standard Playbook Reminder',
      reminder_status: 'Not Scheduled',
      next_scheduled_reminder: '—',
      notes: '',
      services: [],
      brands: [],
      access: [],
      assigned_templates: []
    };
  }

  normalizeClient(client = {}) {
return {
...this.getClientDefaults(),
...client,
id: client.id || '',
business_name: client.business_name || 'Unnamed Client'
};
}

 async loadClients() {
  const container = this.root.querySelector('[data-aa-clients-list]');
  const previousClientId = this.activeClientId;

  if (container) {
    container.innerHTML = '<p>Loading clients...</p>';
  }

  try {
    if (!window.AASupabaseClient?.getClients) {
      throw new Error('AASupabaseClient.getClients() is not available.');
    }

    const clientRows = await window.AASupabaseClient.getClients();

    this.archivedClients = (clientRows || []).filter(
      (client) =>
        String(client.active_status || '')
          .trim()
          .toLowerCase() === 'archived'
    );

    this.clients = await Promise.all(
      (clientRows || [])
        .filter(
          (client) =>
            String(client.active_status || '')
              .trim()
              .toLowerCase() !== 'archived'
        )
        .map(async (client) => {
        const configuration =
  await window.AASupabaseClient.getClientConfiguration({
    clientId: client.id
  });

const assignedTemplates =
  await window.AASupabaseClient.getClientTemplateAssignments({
    clientId: client.id
  });

const catalogRecords =
  await window.AASupabaseClient.getCatalogRecords({
    clientId: client.id
  });

return this.normalizeClient({
          ...client,
          ...(configuration || {}),
          id: client.id,
          business_name: client.business_name,
          active_status:
            client.active_status ||
            configuration?.active_status ||
            'Pending Setup',
          account_status:
            client.account_status ||
            configuration?.account_status ||
            'Pending Setup',
          invoice_status:
            client.invoice_status ||
            configuration?.invoice_status ||
            'Current',
          services: Array.isArray(configuration?.services)
            ? configuration.services
            : [],
          brands: Array.isArray(configuration?.brands)
            ? configuration.brands
            : [],
          access: Array.isArray(configuration?.access)
            ? configuration.access
            : [],
          notes:
            configuration?.internal_notes ||
            configuration?.notes ||
            '',
          assigned_templates: assignedTemplates || [],
catalog_records: catalogRecords || []
        });
      })
    );

    const requestedClientId =
  new URLSearchParams(window.location.search)
    .get('aa_client');

const requestedClientExists =
  this.clients.some(
    (client) =>
      String(client.id) ===
      String(requestedClientId)
  );

const selectedClientStillExists =
  this.clients.some(
    (client) =>
      String(client.id) ===
      String(previousClientId)
  );

if (requestedClientExists) {
  this.activeClientId =
    requestedClientId;
} else if (selectedClientStillExists) {
  this.activeClientId =
    previousClientId;
} else {
  this.activeClientId = null;
}

this.rememberActiveClientInUrl();

    this.render();
  } catch (error) {
    console.error('Error loading Headquarters clients:', error);

    this.clients = [];
    this.activeClientId = null;

    if (container) {
      container.innerHTML = `
        <div class="aa-client-load-error">
          <p><strong>Supabase request failed.</strong></p>
          <p>${this.escapeHtml(error?.message || 'Unable to load clients.')}</p>
        </div>
      `;
    }
   }
}

getActiveClient() {
  return this.clients.find(
    (client) =>
      String(client.id) === String(this.activeClientId)
  );
}

rememberActiveClientInUrl() {
  const url =
    new URL(window.location.href);

  if (this.activeClientId) {
    url.searchParams.set(
      'aa_client',
      this.activeClientId
    );
  } else {
    url.searchParams.delete(
      'aa_client'
    );
  }

  window.history.replaceState(
    {},
    '',
    `${url.pathname}${url.search}${url.hash}`
  );
}

async loadActiveClientPlaybooks() {
  const client = this.getActiveClient();

  this.clientPlaybooks = [];

  if (
    !client?.id ||
    !window.AAPlaybookService?.getPlaybooksByClient
  ) {
    return;
  }

  this.clientPlaybooksLoading = true;

  try {
    const playbooks =
      await window.AAPlaybookService.getPlaybooksByClient({
        clientId: client.id
      });

    this.clientPlaybooks =
      Array.isArray(playbooks)
        ? playbooks
        : [];
  } catch (error) {
    console.error(
      'Unable to load client Playbooks:',
      error
    );

    this.clientPlaybooks = [];
  } finally {
    this.clientPlaybooksLoading = false;
  }
}

  getAssignedTemplates(client) {
  return Array.isArray(client.assigned_templates) ? client.assigned_templates : [];
}

hasEmailAccess(access = []) {
  return Array.isArray(access) &&
    access.some(
      (item) => String(item).trim().toLowerCase() === 'email'
    );
}

setEmailAccess(access = [], enabled = false) {
  const existing = Array.isArray(access)
    ? access.filter(
        (item) => String(item).trim().toLowerCase() !== 'email'
      )
    : [];

  return enabled
    ? [...existing, 'email']
    : existing;
}

  getStatusOptions() {
    return ['Lead', 'Pending Setup', 'Active', 'Paused', 'Archived'];
  }

  getClientTypeOptions() {
    return ['Monthly Marketing', 'Catalog Only', 'Website Only', 'Email Marketing', 'Social Media', 'Custom'];
  }

  getPackageOptions() {
    return ['Monthly Marketing', 'Catalog Only', 'Website Only', 'Email Marketing', 'Social Media', 'Custom'];
  }

  getReminderOptions() {
    return ['5 & 2 days', '7 & 3 days', 'Weekly', 'None', 'Custom'];
  }

  getReminderTemplateOptions() {
    return ['Standard Playbook Reminder', 'Friendly Follow-Up', 'Final Reminder', 'Custom'];
  }

  render() {
    const container = this.root.querySelector('[data-aa-clients-list]');
    if (!container) return;

    const client = this.getActiveClient();

    container.innerHTML = `
      <div class="aa-client-accounts-shell">
        <div class="aa-client-toolbar">
          <label class="aa-client-toolbar__picker">
            <span>Select Client</span>

            <select data-aa-client-picker>
  <option value="">
    Choose a client...
  </option>

  ${this.clients.map((item) => `
                <option
                  value="${item.id}"
                  ${String(item.id) === String(this.activeClientId) ? 'selected' : ''}
                >
                  ${this.escapeHtml(item.business_name)}
                </option>
              `).join('')}
            </select>
          </label>

          <button
            class="aa-button aa-button--primary"
            type="button"
            data-aa-new-client-toggle
          >
            New Client
          </button>

          ${client ? `
            <div class="aa-client-toolbar__actions">
              <button
                class="aa-button aa-button--small"
                type="button"
                data-aa-view-client-workspace="${client.id}"
              >
                View Workspace
              </button>

              <button
                class="aa-button aa-button--small"
                type="button"
                data-aa-edit-client="${client.id}"
              >
                Edit Client
              </button>

              <a
                class="aa-button aa-button--small"
                href="/pages/artisans-avenue-playbook-builder?client=${encodeURIComponent(client.id)}"
              >
                Templates
              </a>

              <button
                class="aa-button aa-button--small"
                type="button"
                data-aa-archive-client="${client.id}"
              >
                Archive
              </button>
            </div>
          ` : ''}

          ${this.archivedClients.length ? `
            <details class="aa-archived-clients">
              <summary>
                <span>Archived Clients</span>
                <small>${this.archivedClients.length}</small>
              </summary>

              <div class="aa-archived-clients__list">
                ${this.archivedClients.map((archivedClient) => `
                  <div class="aa-archived-client">
                    <span>
                      ${this.escapeHtml(
                        archivedClient.business_name || 'Unnamed Client'
                      )}
                    </span>

                    <button
                      class="aa-client-template-action"
                      type="button"
                      data-aa-restore-client="${archivedClient.id}"
                    >
                      Restore
                    </button>
                  </div>
                `).join('')}
              </div>
            </details>
          ` : ''}
        </div>

        <section class="aa-client-detail-card">
          ${client ? this.renderClientDetails(client) : this.renderEmptyState()}
        </section>
      </div>
    `;
  }

  renderEmptyState() {
    return `
      <p class="aa-card__label">Selected Client</p>
      <h3>No client selected</h3>
      <p>Create or select a client to view account details.</p>
    `;
  }

   renderClientDetails(client) {
    return `
      <div class="aa-client-overview">

        <header class="aa-client-overview__header">
          <div>
            <div class="aa-client-overview__title-row">
              <h2>${this.escapeHtml(client.business_name)}</h2>

              <span class="aa-client-status-pill">
                ${this.escapeHtml(client.active_status)}
              </span>
            </div>

            <p class="aa-client-overview__subtitle">
              ${this.escapeHtml(client.current_package || client.client_type)}
            </p>
          </div>

          <div class="aa-client-card__actions">
            <button
              class="aa-button aa-button--primary"
              type="button"
              data-aa-view-client-workspace="${client.id}"
            >
              View Workspace
            </button>

            <a
              class="aa-button"
              href="/pages/artisans-avenue-playbook-builder?client=${encodeURIComponent(client.id)}"
            >
              Templates
            </a>

            <button
              class="aa-button"
              type="button"
              data-aa-edit-client="${client.id}"
            >
              Edit Client
            </button>

            <button
              class="aa-button"
              type="button"
              data-aa-archive-client="${client.id}"
            >
              Archive
            </button>
          </div>
        </header>

        ${String(this.editingClientId) === String(client.id)
          ? this.renderEditClient(client)
          : ''
        }

        <div class="aa-client-overview__quick-grid">
          ${this.renderClientSummary(client)}
          ${this.renderMarketingSetup(client)}
        </div>

       ${this.renderTemplatePanel(client)}

${this.renderPlaybooksPanel(client)}

${this.renderCatalogPanel(client)}

${this.renderReminderPanel(client)}

        <div class="aa-client-overview__secondary">
          ${this.renderContractPanel(client)}
          ${this.renderInternalNotesPanel(client)}
        </div>

      </div>
    `;
  }

  renderClientSummary(client) {
    return `
      <section class="aa-client-compact-panel">
        <p class="aa-card__label">Client Details</p>

        <div class="aa-client-detail-list">
          <div>
            <span>Primary Contact</span>
            <strong>${this.escapeHtml(client.primary_contact || 'Not added')}</strong>
          </div>

          <div>
            <span>Email</span>
            <strong>${this.escapeHtml(client.email || 'Not added')}</strong>
          </div>

          <div>
            <span>Phone</span>
            <strong>${this.escapeHtml(client.phone || 'Not added')}</strong>
          </div>

          <div>
            <span>Playbook Due</span>
            <strong>${this.escapeHtml(client.monthly_due_day || '15')}th</strong>
          </div>
        </div>
      </section>
    `;
  }

  renderMarketingSetup(client) {
    const services = Array.isArray(client.services)
      ? client.services
      : [];

    const brands = Array.isArray(client.brands)
      ? client.brands
      : [];

    const platformAccess = Array.isArray(client.access)
      ? client.access.filter(
          (item) =>
            String(item).trim().toLowerCase() !== 'email'
        )
      : [];

    return `
      <section class="aa-client-compact-panel">
        <p class="aa-card__label">Marketing Setup</p>

        <div class="aa-client-setup-row">
          <span>Services</span>

          <div class="aa-client-chip-list">
            ${services.length
              ? services.map((service) => `
                  <span class="aa-client-chip">
                    ${this.escapeHtml(
                      String(service)
                        .replaceAll('_', ' ')
                        .replace(/\b\w/g, (letter) => letter.toUpperCase())
                    )}
                  </span>
                `).join('')
              : '<span class="aa-client-empty-value">None added</span>'
            }
          </div>
        </div>

        <div class="aa-client-setup-row">
          <span>Brands</span>

          <div class="aa-client-chip-list">
            ${brands.length
              ? brands.map((brand) => `
                  <span class="aa-client-chip">
                    ${this.escapeHtml(brand)}
                  </span>
                `).join('')
              : '<span class="aa-client-empty-value">No brands added</span>'
            }
          </div>
        </div>

        <div class="aa-client-setup-row">
          <span>Email Module</span>

          <strong>
            ${this.hasEmailAccess(client.access) ? 'On' : 'Off'}
          </strong>
        </div>

        <div class="aa-client-setup-row">
          <span>Platform Access</span>

          <div class="aa-client-chip-list">
            ${platformAccess.length
              ? platformAccess.map((access) => `
                  <span class="aa-client-chip">
                    ${this.escapeHtml(access)}
                  </span>
                `).join('')
              : '<span class="aa-client-empty-value">None added</span>'
            }
          </div>
        </div>
      </section>
    `;
  }

  getCatalogRecords(client) {
  return Array.isArray(client.catalog_records)
    ? client.catalog_records
    : [];
}

formatCatalogMonth(value) {
  if (!value) return '—';

  const [year, month] = String(value).split('-');

  if (!year || !month) {
    return value;
  }

  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
  }).format(
    new Date(Date.UTC(Number(year), Number(month) - 1, 1))
  );
}

formatCatalogDate(value) {
  if (!value) return '—';

  const [year, month, day] = String(value).split('-');

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC'
  }).format(
    new Date(
      Date.UTC(
        Number(year),
        Number(month) - 1,
        Number(day)
      )
    )
  );
}

renderCatalogForm(client, catalog = null) {
  const isEditing = Boolean(catalog?.id);

  const clientBrands = Array.isArray(client.brands)
    ? client.brands
    : [];

  const catalogBrands = Array.isArray(catalog?.brands)
    ? catalog.brands
    : [];

  const additionalBrands = catalogBrands.filter(
    (brand) =>
      !clientBrands.some(
        (clientBrand) =>
          String(clientBrand).trim().toLowerCase() ===
          String(brand).trim().toLowerCase()
      )
  );

  const catalogMonth = catalog?.catalog_month
    ? String(catalog.catalog_month).slice(0, 7)
    : '';

  return `
    <form
      class="aa-client-catalog-form"
      data-aa-catalog-form="${client.id}"
      ${isEditing
        ? `data-aa-catalog-edit-id="${catalog.id}"`
        : ''
      }
    >
      <div class="aa-client-catalog-form__grid">

        <label>
          Catalog Month
          <input
            type="month"
            data-aa-catalog-field="catalogMonth"
            value="${this.escapeHtml(catalogMonth)}"
            required
          >
        </label>

        <label>
          Catalog Title
          <input
            type="text"
            data-aa-catalog-field="catalogTitle"
            value="${this.escapeHtml(
              catalog?.catalog_title || ''
            )}"
            required
          >
        </label>

        <label>
          Publication Date
          <input
            type="date"
            data-aa-catalog-field="publicationDate"
            value="${this.escapeHtml(
              catalog?.publication_date || ''
            )}"
          >
        </label>

        <label>
          Catalog Views
          <input
            type="number"
            min="0"
            step="1"
            data-aa-catalog-field="catalogViews"
            value="${catalog?.catalog_views ?? ''}"
          >
        </label>

        <label class="aa-client-catalog-form__wide">
          Catalog URL
          <input
            type="url"
            data-aa-catalog-field="catalogUrl"
            value="${this.escapeHtml(
              catalog?.catalog_url || ''
            )}"
            placeholder="https://..."
            required
          >
        </label>

        <label class="aa-client-catalog-form__wide">
          ${isEditing ? 'Replace Cover Image' : 'Cover Image'}

          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            data-aa-catalog-cover
            ${isEditing ? '' : 'required'}
          >

          <small>
            ${isEditing
              ? 'Leave blank to keep the current cover.'
              : 'JPG, PNG or WebP. Maximum 10 MB.'
            }
          </small>
        </label>

        ${isEditing && catalog?.cover_image_url
          ? `
            <div class="aa-client-catalog-form__current-cover">
              <span>Current Cover</span>

              <img
                src="${this.escapeHtml(
                  catalog.cover_image_url
                )}"
                alt="${this.escapeHtml(
                  catalog.catalog_title || 'Catalog cover'
                )}"
              >
            </div>
          `
          : ''
        }

        <fieldset class="aa-client-catalog-form__wide">
          <legend>Brands Represented</legend>

          ${clientBrands.length
            ? `
              <div class="aa-client-catalog-brand-options">
                ${clientBrands.map((brand) => {
                  const checked = catalogBrands.some(
                    (catalogBrand) =>
                      String(catalogBrand)
                        .trim()
                        .toLowerCase() ===
                      String(brand)
                        .trim()
                        .toLowerCase()
                  );

                  return `
                    <label class="aa-client-catalog-brand-option">
                      <input
                        type="checkbox"
                        value="${this.escapeHtml(brand)}"
                        data-aa-catalog-brand
                        ${checked ? 'checked' : ''}
                      >
                      <span>${this.escapeHtml(brand)}</span>
                    </label>
                  `;
                }).join('')}
              </div>
            `
            : `
              <p class="aa-client-empty-value">
                No Brands Carried have been added to this client yet.
              </p>
            `
          }

          <label>
            Additional Brands
            <input
              type="text"
              data-aa-catalog-additional-brands
              value="${this.escapeHtml(
                additionalBrands.join(', ')
              )}"
              placeholder="Comma separated"
            >
          </label>
        </fieldset>

      </div>

      <div class="aa-client-card__actions">
        <button
          class="aa-button aa-button--primary"
          type="submit"
          data-aa-save-catalog
        >
          ${isEditing ? 'Save Changes' : 'Save Catalog'}
        </button>

        <button
          class="aa-button"
          type="button"
          data-aa-cancel-catalog
        >
          Cancel
        </button>
      </div>
    </form>
  `;
}

renderCatalogPanel(client) {
  const catalogs = this.getCatalogRecords(client);

  return `
    <details class="aa-client-operation-panel aa-client-operation-panel--collapsible aa-client-catalog-panel">
      <summary class="aa-client-operation-panel__summary">
        <div>
          <p class="aa-card__label">Co-op & Catalogs</p>

          <p class="aa-client-operation-panel__description">
            Permanent catalog history for reporting and client records.
          </p>
        </div>

        <span class="aa-client-operation-panel__toggle"></span>
      </summary>

      <div class="aa-client-operation-panel__body">

        <div class="aa-client-operation-panel__body-actions">
          <button
            class="aa-button aa-button--small"
            type="button"
            data-aa-add-catalog="${client.id}"
          >
            Add Catalog
          </button>
        </div>

      ${(() => {
  if (
    String(this.addingCatalogClientId) ===
    String(client.id)
  ) {
    return this.renderCatalogForm(client);
  }

  if (this.editingCatalogId) {
    const catalog = catalogs.find(
      (item) =>
        String(item.id) ===
        String(this.editingCatalogId)
    );

    if (catalog) {
      return this.renderCatalogForm(
        client,
        catalog
      );
    }
  }

  return '';
})()}

<div class="aa-client-catalog-list">
        ${catalogs.length
          ? catalogs.map((catalog) => {
              const brands = Array.isArray(catalog.brands)
                ? catalog.brands
                : [];

              const catalogUrl =
                catalog.catalog_url || '';

              return `
                <div
                  class="aa-client-catalog-item"
                  data-aa-catalog-record="${catalog.id}"
                >
                  <div class="aa-client-catalog-item__cover">
                    ${catalog.cover_image_url
                      ? `
                        <img
                          src="${this.escapeHtml(catalog.cover_image_url)}"
                          alt="${this.escapeHtml(
                            catalog.catalog_title || 'Catalog cover'
                          )}"
                          loading="lazy"
                        >
                      `
                      : `
                        <div class="aa-client-catalog-item__cover-placeholder">
                          No Cover
                        </div>
                      `
                    }
                  </div>

                  <div class="aa-client-catalog-item__details">
                    <strong>
                      ${this.escapeHtml(
                        this.formatCatalogMonth(
                          catalog.catalog_month
                        )
                      )}
                    </strong>

                    <span>
                      ${this.escapeHtml(
                        catalog.catalog_title || 'Untitled Catalog'
                      )}
                    </span>

                    <small>
                      Published:
                      ${this.escapeHtml(
                        this.formatCatalogDate(
                          catalog.publication_date
                        )
                      )}
                    </small>
                  </div>

                  <div class="aa-client-catalog-item__meta">
                    <span>
                      Views:
                      <strong>
                        ${catalog.catalog_views ?? '—'}
                      </strong>
                    </span>

                    <div class="aa-client-chip-list">
                      ${brands.length
                        ? brands.map((brand) => `
                            <span class="aa-client-chip">
                              ${this.escapeHtml(brand)}
                            </span>
                          `).join('')
                        : `
                            <span class="aa-client-empty-value">
                              No brands added
                            </span>
                          `
                      }
                    </div>
                  </div>

                  <div class="aa-client-catalog-item__actions">
                    ${catalogUrl
                      ? `
                        <a
                          class="aa-client-template-action"
                          href="${this.escapeHtml(catalogUrl)}"
                          target="_blank"
                          rel="noopener"
                        >
                          Open Catalog
                        </a>
                      `
                      : ''
                    }

                    <button
                      class="aa-client-template-action"
                      type="button"
                      data-aa-edit-catalog="${catalog.id}"
                    >
                      Edit
                    </button>

                    <button
                      class="aa-client-template-action"
                      type="button"
                      data-aa-archive-catalog="${catalog.id}"
                    >
                      Archive
                    </button>
                  </div>
                </div>
              `;
            }).join('')
          : `
            <div class="aa-client-empty-row">
              No catalog history yet.
            </div>
          `
        }
      </div>
      </div>
    </details>
  `;
}

renderTemplatePanel(client) {
  const assignments = this.getAssignedTemplates(client);

  const activeAssignments = assignments.filter(
    (template) =>
      String(template.assignmentStatus || '')
        .trim()
        .toLowerCase() !== 'archived'
  );

  const archivedAssignments = assignments.filter(
    (template) =>
      String(template.assignmentStatus || '')
        .trim()
        .toLowerCase() === 'archived'
  );

  return `
    <details class="aa-client-operation-panel aa-client-operation-panel--collapsible">
      <summary class="aa-client-operation-panel__summary">
        <div>
          <p class="aa-card__label">Templates & Playbooks</p>
          <p class="aa-client-operation-panel__description">
            Monthly templates assigned to this client.
          </p>
        </div>

        <span class="aa-client-operation-panel__toggle"></span>
      </summary>

      <div class="aa-client-operation-panel__body">

        <div class="aa-client-operation-panel__body-actions">
          <a
            class="aa-button aa-button--small"
            href="/pages/artisans-avenue-playbook-builder?client=${encodeURIComponent(client.id)}"
          >
            Manage Templates
          </a>
        </div>

      <div class="aa-client-template-table">

        ${activeAssignments.length
          ? activeAssignments.map((template) => {
              const status =
                String(template.assignmentStatus || 'assigned')
                  .trim()
                  .toLowerCase();

              const isGenerated = status === 'generated';

              return `
                <div class="aa-client-template-item">

                  <div class="aa-client-template-item__name">
                    <strong>
                      ${this.escapeHtml(
                        template.templateName || 'Unnamed Template'
                      )}
                    </strong>
                  </div>

                  <div class="aa-client-template-item__actions">

                    ${isGenerated
                      ? `
                        <span class="aa-client-template-status">
                          In Use
                        </span>
                      `
                      : `
                        <span class="aa-client-template-status">
                          Assigned
                        </span>

                        <button
  class="aa-client-template-action"
  type="button"
  data-aa-archive-template-assignment="${template.id}"
>
  Archive
</button>

<button
  class="aa-client-template-action aa-client-template-action--delete"
  type="button"
  data-aa-delete-template-assignment="${template.id}"
>
  Delete
</button>
                      `
                    }
                    

                  </div>

                </div>
              `;
            }).join('')
          : `
              <div class="aa-client-empty-row">
                No active templates assigned.
              </div>
            `
        }

      </div>

      ${archivedAssignments.length
        ? `
          <details class="aa-client-archived-templates">
            <summary>
              Archived Templates
              <span>${archivedAssignments.length}</span>
            </summary>

            <div class="aa-client-template-table">

              ${archivedAssignments.map((template) => `
                <div class="aa-client-template-item">

                  <div class="aa-client-template-item__name">
                    <strong>
                      ${this.escapeHtml(
                        template.templateName || 'Unnamed Template'
                      )}
                    </strong>
                  </div>

                  <div class="aa-client-template-item__actions">
                    <span class="aa-client-template-status">
                      Archived
                    </span>

                    <button
  class="aa-client-template-action"
  type="button"
  data-aa-restore-template-assignment="${template.id}"
>
  Restore
</button>

<button
  class="aa-client-template-action aa-client-template-action--delete"
  type="button"
  data-aa-delete-template-assignment="${template.id}"
>
  Delete
</button>
                  </div>

                </div>
              `).join('')}

            </div>
          </details>
        `
        : ''
      }

      </div>
    </details>
  `;
}

renderPlaybooksPanel(client) {
  const playbooks =
    Array.isArray(this.clientPlaybooks)
      ? [...this.clientPlaybooks]
      : [];

  playbooks.sort((a, b) => {
    const aValue =
      Number(
        `${a.year || 0}${String(a.month || 0).padStart(2, '0')}`
      );

    const bValue =
      Number(
        `${b.year || 0}${String(b.month || 0).padStart(2, '0')}`
      );

    return bValue - aValue;
  });

  const monthNames = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  return `
    <details class="aa-client-operation-panel aa-client-operation-panel--collapsible">
      <summary class="aa-client-operation-panel__summary">
        <div>
          <p class="aa-card__label">Client Playbooks</p>

          <p class="aa-client-operation-panel__description">
            Review monthly Playbooks for this client.
          </p>
        </div>

        <span class="aa-client-operation-panel__toggle"></span>
      </summary>

      <div class="aa-client-operation-panel__body">
        <div class="aa-client-template-table">

        ${
          this.clientPlaybooksLoading
            ? `
              <div class="aa-client-empty-row">
                Loading Playbooks...
              </div>
            `
            : playbooks.length
              ? playbooks.map((playbook) => {
                  const monthName =
                    monthNames[Number(playbook.month)] ||
                    playbook.month ||
                    'Playbook';

                  const status =
                    String(playbook.status || 'draft')
                      .replaceAll('_', ' ')
                      .replace(/\b\w/g, (letter) =>
                        letter.toUpperCase()
                      );

                  return `
                    <div class="aa-client-template-item">

                      <div class="aa-client-template-item__name">
                        <strong>
                          ${this.escapeHtml(
                            `${monthName} ${playbook.year}`
                          )}
                        </strong>

                        <small>
                          ${this.escapeHtml(status)}
                        </small>
                      </div>

                      <div class="aa-client-template-item__actions">
                        <button
                          class="aa-client-template-action"
                          type="button"
                          data-aa-review-playbook="${playbook.id}"
                        >
                          Open Review
                        </button>
                      </div>

                    </div>
                  `;
                }).join('')
              : `
                <div class="aa-client-empty-row">
                  No Playbooks have been created for this client yet.
                </div>
              `
        }

        </div>
      </div>
    </details>
  `;
}

renderReminderPanel(client) {
    return `
      <section class="aa-client-operation-panel aa-client-reminder-panel">
        <div>
          <p class="aa-card__label">Playbook Reminders</p>

          <div class="aa-client-reminder-summary">
            <span>
              Due <strong>${this.escapeHtml(client.monthly_due_day || '15')}th</strong>
            </span>

            <span>
              ${this.escapeHtml(client.reminder_schedule)}
            </span>

            <span>
              ${this.escapeHtml(client.reminder_email_template)}
            </span>

            <span>
              Next: ${this.escapeHtml(client.next_scheduled_reminder)}
            </span>
          </div>
        </div>

        <button
          class="aa-button aa-button--small"
          type="button"
          data-aa-manage-reminders="${client.id}"
        >
          Manage Reminders
        </button>
      </section>
    `;
  }

  renderContractPanel(client) {
    return `
      <details class="aa-client-secondary-panel">
        <summary>
          <span>Contract & Billing</span>
          <small>${this.escapeHtml(client.contract_status)}</small>
        </summary>

        <div class="aa-client-secondary-panel__body">
          <p>
            <strong>Contract:</strong>
            ${this.escapeHtml(client.contract_status)}
          </p>

          <p>
            <strong>Invoice Status:</strong>
            ${this.escapeHtml(client.invoice_status)}
          </p>

          <p>
            <strong>Agreement:</strong>
            Monthly service agreement
          </p>

          <p>
            <strong>Signed:</strong>
            Not connected yet
          </p>
        </div>
      </details>
    `;
  }

  renderInternalNotesPanel(client) {
    const hasNotes =
      Boolean(String(client.notes || '').trim());

    return `
      <details class="aa-client-secondary-panel">
        <summary>
          <span>Internal Notes</span>
          <small>${hasNotes ? 'Notes added' : 'No notes'}</small>
        </summary>

        <div class="aa-client-secondary-panel__body">
          <p>
            ${this.escapeHtml(
              client.notes || 'No internal notes yet.'
            )}
          </p>
        </div>
      </details>
    `;
  }

 renderEditClient(client) {
  return `
    <form class="aa-client-edit-panel" data-aa-client-edit-panel="${client.id}">
      <p class="aa-card__label">Edit Client Profile</p>

      <label>
        Business Name
        <input type="text" data-aa-edit-client-field="business_name" value="${this.escapeHtml(client.business_name)}">
      </label>

      <label>
        Primary Contact
        <input type="text" data-aa-edit-client-field="primary_contact" value="${this.escapeHtml(client.primary_contact)}">
      </label>

      <label>
        Email
        <input type="email" data-aa-edit-client-field="email" value="${this.escapeHtml(client.email)}">
      </label>

      <label>
        Phone
        <input type="tel" data-aa-edit-client-field="phone" value="${this.escapeHtml(client.phone)}">
      </label>

      <label>
        Client Type
        <select data-aa-edit-client-field="client_type">

        
          ${this.getClientTypeOptions().map((option) => `
            <option value="${option}" ${client.client_type === option ? 'selected' : ''}>${option}</option>
          `).join('')}
        </select>
      </label>

      <label>
        Current Package
        <select data-aa-edit-client-field="current_package">
          ${this.getPackageOptions().map((option) => `
            <option value="${option}" ${client.current_package === option ? 'selected' : ''}>${option}</option>
          `).join('')}
        </select>
      </label>

      <label>
        Status
        <select data-aa-edit-client-field="active_status">
          ${this.getStatusOptions().map((option) => `
            <option value="${option}" ${client.active_status === option ? 'selected' : ''}>${option}</option>
          `).join('')}
        </select>
      </label>

      <label>
        Monthly Due Day
        <input type="number" min="1" max="31" data-aa-edit-client-field="monthly_due_day" value="${this.escapeHtml(client.monthly_due_day)}">
      </label>

      <label>
        Reminder Schedule
        <select data-aa-edit-client-field="reminder_schedule">
          ${this.getReminderOptions().map((option) => `
            <option value="${option}" ${client.reminder_schedule === option ? 'selected' : ''}>${option}</option>
          `).join('')}
        </select>
      </label>

      <label>
        Reminder Email Template
        <select data-aa-edit-client-field="reminder_email_template">
          ${this.getReminderTemplateOptions().map((option) => `
            <option value="${option}" ${client.reminder_email_template === option ? 'selected' : ''}>${option}</option>
          `).join('')}
        </select>
      </label>

      <label>
        Services
        <input
          type="text"
          data-aa-edit-client-field="services"
          value="${this.escapeHtml((client.services || []).join(', '))}"
          placeholder="Monthly Marketing, Website"
        >
      </label>

      <label>
        Brands Carried
        <input
          type="text"
          data-aa-edit-client-field="brands"
          value="${this.escapeHtml((client.brands || []).join(', '))}"
          placeholder="Baby Lock, PFAFF, Janome"
        >
      </label>

      <label>
  Access
  <input
    type="text"
    data-aa-edit-client-field="access"
    value="${this.escapeHtml(
      (client.access || [])
        .filter((item) => String(item).trim().toLowerCase() !== 'email')
        .join(', ')
    )}"
    placeholder="Shopify, Constant Contact, Meta"
  >
</label>

<label>
  Email Module
  <select data-aa-edit-client-email-access>
    <option value="off" ${this.hasEmailAccess(client.access) ? '' : 'selected'}>Off</option>
    <option value="on" ${this.hasEmailAccess(client.access) ? 'selected' : ''}>On</option>
  </select>
</label>

<label>
  Notes
  <textarea data-aa-edit-client-field="notes">${this.escapeHtml(client.notes || '')}</textarea>
</label>

      <div class="aa-client-card__actions">
        <button class="aa-button aa-button--primary" type="submit" data-aa-save-client-edit="${client.id}">
          Save Client
        </button>

        <button class="aa-button" type="button" data-aa-cancel-client-edit>
          Cancel
        </button>
      </div>
    </form>
  `;
}

  bindNewClientForm() {
  this.root.addEventListener('click', async (event) => {
    const toggle = event.target.closest('[data-aa-new-client-toggle]');
    if (!toggle) return;

    const form = this.root.querySelector('[data-aa-new-client-form]');
    const input = this.root.querySelector('[data-aa-new-client-name]');

    if (!form || !input) return;

let emailAccessField =
  form.querySelector('[data-aa-new-client-email-access]');

if (!emailAccessField) {
  const label = document.createElement('label');

  label.innerHTML = `
    Email Module
    <select data-aa-new-client-email-access>
      <option value="off" selected>Off</option>
      <option value="on">On</option>
    </select>
  `;

  form.insertBefore(
    label,
    form.querySelector('button[type="submit"]') || null
  );

  emailAccessField =
    label.querySelector('[data-aa-new-client-email-access]');
}

form.hidden = !form.hidden;

if (!form.hidden) {
  input.focus();
}
  });

  this.root.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-aa-new-client-form]');
    if (!form) return;

    event.preventDefault();

    const input = form.querySelector('[data-aa-new-client-name]');
const businessName = input?.value.trim();
const submitButton = form.querySelector('[type="submit"]');
const emailAccessField =
  form.querySelector('[data-aa-new-client-email-access]');

const initialAccess =
  emailAccessField?.value === 'on'
    ? ['email']
    : [];

    if (!businessName) return;

    if (!window.AASupabaseClient?.createClient) {
      alert('Supabase request failed. Client creation is not available.');
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Creating Client...';
    }

    try {
      const createdClient = await window.AASupabaseClient.createClient({
        business_name: businessName,
        active_status: 'Pending Setup'
      });

      if (!createdClient?.id) {
        throw new Error('Supabase did not return the new client id.');
      }

      await window.AASupabaseClient.saveClientConfiguration({
        clientId: createdClient.id,
        configuration: {
          current_package: 'Monthly Marketing',
          client_type: 'Monthly Marketing',
          contract_status: 'No Contract',
          invoice_status: 'Current',
          services: [],
          brands: [],
          access: initialAccess,
          reminder_schedule: '5 & 2 days',
          reminder_email_template: 'Standard Playbook Reminder',
          reminder_status: 'Not Scheduled',
          next_scheduled_reminder: '—',
          internal_notes: '',
          assigned_templates: []
        }
      });

      this.activeClientId = createdClient.id;
      this.editingClientId = createdClient.id;

      form.reset();
      form.hidden = true;

      await this.loadClients();

      this.activeClientId = createdClient.id;
      this.editingClientId = createdClient.id;

      this.render();

      this.showStatusMessage('Client created.');
    } catch (error) {
      console.error('Error creating client:', error);

      alert(
        `Supabase request failed: ${
          error?.message || 'Unable to create client.'
        }`
      );
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = 'Create Client';
      }
    }
  });
}

  bindClientActions() {
    this.root.addEventListener('change', async (event) => {
  const picker = event.target.closest('[data-aa-client-picker]');
  if (!picker) return;

  this.activeClientId = picker.value;
this.editingClientId = null;

this.rememberActiveClientInUrl();

await this.loadActiveClientPlaybooks();

this.render();
});

this.root.addEventListener('click', async (event) => {
      const editButton = event.target.closest('[data-aa-edit-client]');
const cancelButton = event.target.closest('[data-aa-cancel-client-edit]');
const viewWorkspaceButton = event.target.closest('[data-aa-view-client-workspace]');
const manageRemindersButton = event.target.closest('[data-aa-manage-reminders]');
const archiveButton = event.target.closest('[data-aa-archive-client]');
const restoreClientButton = event.target.closest('[data-aa-restore-client]');

const archiveTemplateButton =
  event.target.closest('[data-aa-archive-template-assignment]');

const restoreTemplateButton =
  event.target.closest('[data-aa-restore-template-assignment]');

const deleteTemplateButton =
  event.target.closest('[data-aa-delete-template-assignment]');

const archiveCatalogButton =
  event.target.closest('[data-aa-archive-catalog]');

const addCatalogButton =
  event.target.closest('[data-aa-add-catalog]');

const editCatalogButton =
  event.target.closest('[data-aa-edit-catalog]');

const cancelCatalogButton =
  event.target.closest('[data-aa-cancel-catalog]');

  const reviewPlaybookButton =
  event.target.closest('[data-aa-review-playbook]');

  if (reviewPlaybookButton) {
  const playbookId =
    reviewPlaybookButton.dataset.aaReviewPlaybook;

  const clientId =
    this.activeClientId;

  if (!playbookId || !clientId) {
    return;
  }

  window.location.href =
  `/pages/workspace-current-playbook?playbook=${encodeURIComponent(playbookId)}&aa_admin_client=${encodeURIComponent(clientId)}&aa_review=1`;

  return;
}

  if (addCatalogButton) {
  this.addingCatalogClientId =
    addCatalogButton.dataset.aaAddCatalog;

  this.editingCatalogId = null;

  this.render();
  return;
}

if (editCatalogButton) {
  this.editingCatalogId =
    editCatalogButton.dataset.aaEditCatalog;

  this.addingCatalogClientId = null;

  this.render();
  return;
}

if (cancelCatalogButton) {
  this.addingCatalogClientId = null;
  this.editingCatalogId = null;

  this.render();
  return;
}

      if (restoreClientButton) {
        const clientId =
          restoreClientButton.dataset.aaRestoreClient;

        restoreClientButton.disabled = true;
        restoreClientButton.textContent = 'Restoring...';

        try {
          await window.AASupabaseClient.updateClient({
            clientId,
            updates: {
              active_status: 'Active'
            }
          });

          await this.loadClients();

          this.activeClientId = clientId;
          this.editingClientId = null;
          this.render();

          this.showStatusMessage('Client restored.');
        } catch (error) {
          console.error('Error restoring client:', error);

          alert(
            `Supabase request failed: ${
              error?.message || 'Unable to restore client.'
            }`
          );

          restoreClientButton.disabled = false;
          restoreClientButton.textContent = 'Restore';
        }

        return;
      }

      if (deleteTemplateButton) {
    const assignmentId =
      deleteTemplateButton.dataset.aaDeleteTemplateAssignment;

    const confirmed =
      deleteTemplateButton.dataset.aaDeleteConfirmed === 'true';

    if (!confirmed) {
      deleteTemplateButton.dataset.aaDeleteConfirmed = 'true';
      deleteTemplateButton.textContent = 'Confirm Delete';
      return;
    }

    deleteTemplateButton.disabled = true;
    deleteTemplateButton.textContent = 'Deleting...';

    try {
      await window.AASupabaseClient.deleteClientTemplateAssignment({
        assignmentId
      });

      await this.loadClients();

      this.showStatusMessage(
        'Template assignment permanently deleted.'
      );
    } catch (error) {
      console.error(
        'Error deleting template assignment:',
        error
      );

      alert(
        `Supabase request failed: ${
          error?.message ||
          'Unable to delete template assignment.'
        }`
      );

      deleteTemplateButton.disabled = false;
      deleteTemplateButton.textContent = 'Delete';
      deleteTemplateButton.dataset.aaDeleteConfirmed = 'false';
    }

    return;
  }

  if (archiveCatalogButton) {
  const catalogId =
    archiveCatalogButton.dataset.aaArchiveCatalog;

  archiveCatalogButton.disabled = true;
  archiveCatalogButton.textContent = 'Archiving...';

  try {
    await window.AASupabaseClient.archiveCatalogRecord({
      id: catalogId
    });

    await this.loadClients();

    this.showStatusMessage('Catalog archived.');
  } catch (error) {
    console.error('Error archiving catalog:', error);

    alert(
      `Supabase request failed: ${
        error?.message || 'Unable to archive catalog.'
      }`
    );

    archiveCatalogButton.disabled = false;
    archiveCatalogButton.textContent = 'Archive';
  }

  return;
}

  if (archiveTemplateButton) {
        const assignmentId =
          archiveTemplateButton.dataset.aaArchiveTemplateAssignment;

        archiveTemplateButton.disabled = true;
        archiveTemplateButton.textContent = 'Archiving...';

        try {
          await window.AASupabaseClient.updateClientTemplateAssignmentStatus({
            assignmentId,
            status: 'archived'
          });

          await this.loadClients();

          this.showStatusMessage('Template assignment archived.');
        } catch (error) {
          console.error('Error archiving template assignment:', error);

          alert(
            `Supabase request failed: ${
              error?.message || 'Unable to archive template assignment.'
            }`
          );
        }

        return;
      }

      if (restoreTemplateButton) {
        const assignmentId =
          restoreTemplateButton.dataset.aaRestoreTemplateAssignment;

        restoreTemplateButton.disabled = true;
        restoreTemplateButton.textContent = 'Restoring...';

        try {
          await window.AASupabaseClient.updateClientTemplateAssignmentStatus({
            assignmentId,
            status: 'assigned'
          });

          await this.loadClients();

          this.showStatusMessage('Template assignment restored.');
        } catch (error) {
          console.error('Error restoring template assignment:', error);

          alert(
            `Supabase request failed: ${
              error?.message || 'Unable to restore template assignment.'
            }`
          );
        }

        return;
      }

      if (editButton) {
        this.editingClientId = editButton.dataset.aaEditClient;
        this.render();
        return;
      }

      if (cancelButton) {
        this.editingClientId = null;
        this.render();
        return;
      }

      if (viewWorkspaceButton) {
        const clientId =
          viewWorkspaceButton.dataset.aaViewClientWorkspace;

        if (!clientId) return;

        window.location.href =
          `/pages/workspace-dashboard?aa_admin_client=${encodeURIComponent(clientId)}`;

        return;
      }

      if (manageRemindersButton) {
  this.editingClientId = manageRemindersButton.dataset.aaManageReminders;
  this.render();

  requestAnimationFrame(() => {
    const reminderField = this.root.querySelector(
      '[data-aa-edit-client-field="reminder_schedule"]'
    );

    if (reminderField) {
      reminderField.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      reminderField.focus();
    }
  });

  return;
}

if (archiveButton) {
  const clientId = archiveButton.dataset.aaArchiveClient;

  archiveButton.disabled = true;
  archiveButton.textContent = 'Archiving Client...';

  try {
    await window.AASupabaseClient.archiveClient({
      clientId
    });

    this.editingClientId = null;
    this.activeClientId = null;

    await this.loadClients();

    this.activeClientId = this.clients[0]?.id || null;
    this.render();

    this.showStatusMessage('Client archived.');
  } catch (error) {
    console.error('Error archiving client:', error);

    alert(
      `Supabase request failed: ${
        error?.message || 'Unable to archive client.'
      }`
    );

    archiveButton.disabled = false;
    archiveButton.textContent = 'Archive Client';
  }
}
    });

   this.root.addEventListener('submit', async (event) => {
  const catalogForm =
    event.target.closest('[data-aa-catalog-form]');

  if (catalogForm) {
    event.preventDefault();

    const clientId =
  catalogForm.dataset.aaCatalogForm;

const editingCatalogId =
  catalogForm.dataset.aaCatalogEditId || null;

const isEditing =
  Boolean(editingCatalogId);

    const client = this.clients.find(
      (item) => String(item.id) === String(clientId)
    );

    if (!client) {
      return;
    }

    const getField = (name) =>
      catalogForm.querySelector(
        `[data-aa-catalog-field="${name}"]`
      );

    const catalogMonth =
      getField('catalogMonth')?.value || '';

    const catalogTitle =
      getField('catalogTitle')?.value.trim() || '';

    const publicationDate =
      getField('publicationDate')?.value || null;

    const catalogUrl =
      getField('catalogUrl')?.value.trim() || '';

    const catalogViewsRaw =
      getField('catalogViews')?.value.trim() || '';

    const coverInput =
      catalogForm.querySelector('[data-aa-catalog-cover]');

    const coverFile =
      coverInput?.files?.[0] || null;

    const selectedBrands = [
      ...catalogForm.querySelectorAll(
        '[data-aa-catalog-brand]:checked'
      )
    ].map((input) => input.value.trim());

    const additionalBrands =
      (
        catalogForm.querySelector(
          '[data-aa-catalog-additional-brands]'
        )?.value || ''
      )
        .split(',')
        .map((brand) => brand.trim())
        .filter(Boolean);

    const brands = [
      ...new Set([
        ...selectedBrands,
        ...additionalBrands
      ])
    ];

    if (!catalogMonth) {
      alert('Catalog Month is required.');
      return;
    }

    if (!catalogTitle) {
      alert('Catalog Title is required.');
      return;
    }

    if (!catalogUrl) {
      alert('Catalog URL is required.');
      return;
    }

    if (!isEditing && !coverFile) {
  alert('Please choose a catalog cover image.');
  return;
}

    const normalizedMonth =
      `${catalogMonth}-01`;

    const duplicate =
  this.getCatalogRecords(client).find(
    (catalog) =>
      String(catalog.catalog_month) ===
        String(normalizedMonth) &&
      String(catalog.id) !==
        String(editingCatalogId || '')
  );

    if (duplicate) {
      alert(
        'An active catalog already exists for this client and month. Edit the existing catalog instead.'
      );
      return;
    }

    const catalogViews =
      catalogViewsRaw === ''
        ? null
        : Number(catalogViewsRaw);

    if (
      catalogViews !== null &&
      (
        !Number.isInteger(catalogViews) ||
        catalogViews < 0
      )
    ) {
      alert(
        'Catalog Views must be a whole number of 0 or greater.'
      );
      return;
    }

    const submitButton =
      catalogForm.querySelector(
        '[data-aa-save-catalog]'
      );

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Saving Catalog...';
    }

    try {
     let coverImageUrl = null;

if (coverFile) {
  const uploadedCover =
    await window.AASupabaseClient.uploadCatalogCover({
      clientId,
      file: coverFile
    });

  coverImageUrl =
    uploadedCover.publicUrl;
}

if (isEditing) {
  const updates = {
    catalogMonth,
    catalogTitle,
    publicationDate,
    catalogUrl,
    catalogViews,
    brands
  };

  if (coverImageUrl) {
    updates.coverImageUrl =
      coverImageUrl;
  }

  const updatedCatalog =
    await window.AASupabaseClient.updateCatalogRecord({
      id: editingCatalogId,
      updates
    });

  if (!updatedCatalog?.id) {
    throw new Error(
      'Supabase did not return the updated catalog record.'
    );
  }
} else {
  const createdCatalog =
    await window.AASupabaseClient.createCatalogRecord({
      clientId,
      catalogMonth,
      catalogTitle,
      publicationDate,
      catalogUrl,
      coverImageUrl,
      catalogViews,
      brands
    });

  if (!createdCatalog?.id) {
    throw new Error(
      'Supabase did not return the new catalog record.'
    );
  }
}

this.addingCatalogClientId = null;
this.editingCatalogId = null;


this.activeClientId = clientId;

      await this.loadClients();

      this.activeClientId = clientId;
      this.render();

     this.showStatusMessage(
  isEditing
    ? 'Catalog updated.'
    : 'Catalog added.'
);
    } catch (error) {
      console.error('Error creating catalog:', error);

      if (
        error?.code ===
        'AA_DUPLICATE_CATALOG_MONTH'
      ) {
        alert(
          'An active catalog already exists for this client and month. Edit the existing catalog instead.'
        );
      } else {
        alert(
          `Supabase request failed: ${
            error?.message ||
            'Unable to create catalog.'
          }`
        );
      }

      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent =
  isEditing
    ? 'Save Changes'
    : 'Save Catalog';
      }
    }

    return;
  }

  const form =
    event.target.closest('[data-aa-client-edit-panel]');

  if (!form) return;

  event.preventDefault();

  const clientId = form.dataset.aaClientEditPanel;
  const client = this.clients.find(
    (item) => String(item.id) === String(clientId)
  );

  if (!client) return;

  const submitButton = form.querySelector('[data-aa-save-client-edit]');
  const updatedClient = { ...client };

 form.querySelectorAll('[data-aa-edit-client-field]').forEach((field) => {
  const key = field.dataset.aaEditClientField;

  if (
    key === 'services' ||
    key === 'brands' ||
    key === 'access'
  ) {
    updatedClient[key] = field.value
      .split(',')
      .map((item) => item.trim())
      .filter(Boolean);
  } else {
    updatedClient[key] = field.value.trim();
  }
});

const emailAccessField =
  form.querySelector('[data-aa-edit-client-email-access]');

updatedClient.access = this.setEmailAccess(
  updatedClient.access,
  emailAccessField?.value === 'on'
);

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = 'Saving Client...';
  }

  try {
    const latestConfiguration =
      (await window.AASupabaseClient.getClientConfiguration({
        clientId
      })) || {};

    await window.AASupabaseClient.updateClient({
      clientId,
      updates: {
        business_name: updatedClient.business_name,
        primary_contact: updatedClient.primary_contact,
        email: updatedClient.email,
        phone: updatedClient.phone,
        active_status: updatedClient.active_status
      }
    });

    const mergedConfiguration = {
  ...latestConfiguration,
  primary_contact: updatedClient.primary_contact,
  email: updatedClient.email,
  phone: updatedClient.phone,
  current_package: updatedClient.current_package,
  client_type: updatedClient.client_type,
  contract_status: updatedClient.contract_status,
  invoice_status: updatedClient.invoice_status,
      services: updatedClient.services,
      brands: updatedClient.brands,
      access: updatedClient.access,
      reminder_schedule: updatedClient.reminder_schedule,
      reminder_email_template: updatedClient.reminder_email_template,
      reminder_status: updatedClient.reminder_status,
      next_scheduled_reminder: updatedClient.next_scheduled_reminder,
      monthly_due_day: updatedClient.monthly_due_day,
      internal_notes: updatedClient.notes,
      assigned_templates:
        latestConfiguration.assigned_templates ||
        updatedClient.assigned_templates ||
        []
    };

    await window.AASupabaseClient.saveClientConfiguration({
      clientId,
      configuration: mergedConfiguration
    });

    this.activeClientId = clientId;
    this.editingClientId = null;

    await this.loadClients();

    this.activeClientId = clientId;
    this.render();

    this.showStatusMessage('Client saved.');
  } catch (error) {
    console.error('Error saving client:', error);

    alert(
      `Supabase request failed: ${
        error?.message || 'Unable to save client.'
      }`
    );
  } finally {
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = 'Save Client';
    }
  }
});
  }
}

window.AAHeadquartersClients = AAHeadquartersClients;